import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HttpApis from "../../services/HttpApis";
import "./style.css";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import { MdKeyboardArrowLeft } from "react-icons/md";

const notyf = new Notyf({ position: { x: "center", y: "center" } });

function CreateProfile() {
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [name, setName] = useState("");
  const [avatars, setAvatars] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAvatars = async () => {
      try {
        const response = await HttpApis.getAllAvatarImg();
        if (response.data && response.data.data) {
          setAvatars(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching avatars:", error);
      }
    };

    fetchAvatars();
  }, []);

  const handleCreateProfile = async () => {
    if (isSubmitting) return;
    if (!name && !selectedAvatar) {
      notyf.error("Please enter a name and select an avatar");
      return;
    }
    if (!selectedAvatar) {
      notyf.error("Please select your avatar");
      return;
    }
    if (!name) {
      notyf.error("Please enter your name");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        name: name,
        avatar: selectedAvatar,
        language: "english",
        preferences: ""
      };

      await HttpApis.postCreateProfile(payload);

      // ✅ redirect to /profile after success
      navigate("/profile");
    } catch (error) {
      console.error("Error creating profile:", error);
      notyf.error("Failed to create profile. Please try again.");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="profile-container">
      <div className="profile-content">
        <h2 className="profile-title">Create your profile</h2>

        <div className="avatar-container">
          {avatars.map((avatar) => (
            <div className="avatar-wrapper" key={avatar.id}>
              <button
                className={`avatar-button ${selectedAvatar === avatar.id ? "selected" : ""
                  }`}
                onClick={() => setSelectedAvatar(avatar.id)}
              >
                <img
                  src={avatar.image_url || avatar.avatar_img}
                  alt={avatar.name || "avatar"}
                  className="avatar-image"
                />
              </button>
            </div>
          ))}
        </div>

        <div className="profile-input-container">
          <input
            type="text"
            placeholder="Enter profile name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="profile-input"
          />
        </div>

        <div className="button-container profile-button-spacing">
          <button
            className="profile-button"
            onClick={handleCreateProfile}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>

        </div>
        <div className="paraText clickable" onClick={() => {
          navigate("/profile")
        }} style={{ cursor: "pointer" }}>
          <span><MdKeyboardArrowLeft className="arrowIcon" /></span> Go Back
        </div>
      </div>
    </div>
  );
}

export default CreateProfile;